import { ApiManager } from 'utlis/api_manager';
import http from 'utlis/http';

const api = new ApiManager(process.env.REACT_APP_BASE_URL, 1);

const designAuditApi = process.env.REACT_APP_DESIGN_AUDIT_BASE_URL;

export default class TeamDashboardReviews {
  static async submitReview(params = {}) {
    if (params.formData instanceof FormData) {
      return http.post(`${designAuditApi}/generate_review`, params.formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-BACKEND-URL': process.env.REACT_APP_X_BACKEND_URL,
        },
      });
    }
  }
}

export const getSingleDesignReview = async reviewUuid => {
  const url = `project/team/design-reviews/${reviewUuid}`;

  try {
    const { data } = await api.setUrl(url).get();

    return data;
  }
  catch (e) {
    console.error(e);

    throw e;
  }
};

export const getDesignReviewJobStatus = async jobId => {
  if (!jobId) {
    throw new Error('jobId is required to fetch design review status');
  }

  const url = `user/reviewer/design_review/${jobId}`;

  try {
    const { data } = await api.setUrl(url).get();

    return data;
  }
  catch (error) {
    console.error('Error fetching design review job status:', error);

    throw error;
  }
};

export const getPublicDesignReview = async reviewUuid => {
  if (!reviewUuid) {
    throw new Error('reviewUuid is required to fetch public design review');
  }

  const url = `project/public/design-reviews/${reviewUuid}`;

  try {
    const { data } = await api.setUrl(url).get();

    return data;
  }
  catch (error) {
    console.error('Error fetching public design review:', error);

    throw error;
  }
};
